export const ONLINE_PAYMENT_FEE_FIXED_EUR = 0.35;
export const ONLINE_PAYMENT_FEE_RATE = 0.045; // 4.5%

const roundMoney = (value: number) => Math.round(value * 100) / 100;

export function calculateOnlinePaymentFee(baseAmount: number): number {
	if (baseAmount <= 0) return 0;
	return roundMoney(
		baseAmount * ONLINE_PAYMENT_FEE_RATE + ONLINE_PAYMENT_FEE_FIXED_EUR,
	);
}
